export const SET_LOADING = 'SET_LOADING'
export const SET_BREADCRUMB_ITEMS = 'SET_BREADCRUMB_ITEMS'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js